import { COUNTRIES, Country } from 'constants/countries';

const getCountryNameFromShopifyCountryName = (name: string): string => {
    name = name.toLowerCase();
    switch (name) {
        case 'czech republic':
            return 'czechia';
        default:
            return name;
    }
};

const getOnlyCountries = (): Country[] => {
    return Object.values(COUNTRIES)
        .reduce((a, b) => a.concat(b))
        .sort(function (a, b): number {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        })
        .filter((c) => c.code !== 'PR');
};

export default {
    getCountryNameFromShopifyCountryName,
    getOnlyCountries,
};
